import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "../hooks/useAuth";

// Gate that holds protected routes until the stored session has been restored.
// Nothing below it renders (and no protected request fires) while the auth
// provider is still bootstrapping, so there is no premature redirect to the
// login page and no request sent with a stale token.
const PersistLogin = () => {
  const { isBootstrapping } = useAuth();
  const { t } = useTranslation();

  if (isBootstrapping) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-surface-muted text-sm text-slate-500"
      >
        <span className="ui-spinner h-8 w-8" aria-hidden="true" />
        <span>{t("app.restoringSession")}</span>
      </div>
    );
  }

  return <Outlet />;
};

export default PersistLogin;
